import axios from "axios";

export const state = {
    countries: [],
};

export const getters = {
    countries: state => state.countries,
};

export const mutations = {
    setCountries(state, newValue) {
        state.countries = newValue
    },
};

export const actions = {
    fetchCountries({ commit }) {
        axios.get('/countries').then(res => {
            commit('setCountries', res.data.countries);
        })
    },
};
